import { render, staticRenderFns } from "./TranscriptModal.vue?vue&type=template&id=60b50196&"
import script from "./TranscriptModal.vue?vue&type=script&lang=js&"
export * from "./TranscriptModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports